import { z } from 'zod';

export const getRolesSchema = z.array(
  z.object({
    id: z.string(),
    code: z.string(),
    name: z.string(),
    isFromManager: z.boolean(),
    isActive: z.boolean(),
    deleted: z.boolean(),
  })
);

export type GetRolesResponse = z.infer<typeof getRolesSchema>;
